import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { PtReservationMenuService } from '../../core/services/pt-reservation-menu.service';
import { StudioSelectionService } from '../../core/services/studio-selection.service';
import { PagerComponent } from '../../shared/components/pager.component';

const SESSION_KEY = 'pt_reservation_select_studio_id';
const RESERVE_SLOT = 15;

@Component({
    selector: 'app-pt-reservation-menu',
    imports: [MaxLengthValidatorDirective, RouterLink, FormsModule, DecimalPipe, PagerComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> メニュー</span>
        </div>
        <div class="card-body">
          <form novalidate name="myForm">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="studio_name">店舗</label>
                    <select class="form-control" id="studio_name" name="studio_name"
                      [(ngModel)]="selectedStudio" (ngModelChange)="onStudioChange()">
                      <option [ngValue]="null">-- 選択してください --</option>
                      @for (s of studios; track s.id) {
                        <option [ngValue]="s">{{s.name}}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <hr>
        </div>
        <div class="card-body">
          <div class="row form-group">
            <div class="col-md-12">
              <button class="form-group btn btn-primary text-white" type="button"
                [disabled]="!selectedStudio" (click)="openAddModal()">
                <i class="fa s-icon-edit mr-1"></i>&nbsp;新規作成
              </button>
            </div>
          </div>
          @if (selectedStudio && !searching && items.length === 0) {
            <span>該当するデータはありません</span>
          }
          @if (items.length > 0) {
            <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
          } @else {
            <ul class="pagination pull-right"></ul>
          }
          <table class="table table-bordered table-sm table-hover table-ptb-0">
            <thead>
              <tr>
                <th width="10%">状態</th>
                <th width="15%">予約種別</th>
                <th width="30%">メニュー名</th>
                <th width="10%">予約枠</th>
                <th width="10%">予約表示時間</th>
                <th width="10%">金額</th>
                <th width="15%"></th>
              </tr>
            </thead>
            <tbody>
              @for (item of pagedItems; track item.id) {
                <tr>
                    <td class="text-center">
                      @if (item.status === 0) {
                        <button class="btn text-secondary bg-inherit p-0 active" type="button" (click)="enable(item)">
                          <i class="fa fa-3x fa-toggle-off"></i>
                        </button>
                      }
                      @if (item.status === 1) {
                        <button class="btn text-green p-0 bg-inherit active" type="button" (click)="disable(item)">
                          <i class="fa fa-3x fa-toggle-on"></i>
                        </button>
                      }
                    </td>
                    <td>
                      @if (item.menuType === 0) { <span>会員向け</span> }
                      @if (item.menuType === 1) { <span>非会員向け</span> }
                    </td>
                    <td>{{item.menuName || item.name}}</td>
                    <td class="text-right">{{formatTimePerSlot(item)}}</td>
                    <td class="text-right">{{formatRequiredTime(item)}}</td>
                    <td class="text-right">{{formatMenuAmount(item)}}</td>
                    <td class="text-center">
                      <button type="button" class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                        title="編集" (click)="openEditModal(item)">
                        <i class="fa s-icon-edit fa-fw"></i>
                      </button>
                      @if (item.status === 1) {
                        <button class="mt-1 mb-1 btn btn-secondary btn-sm text-white" type="button" disabled>
                          <i class="fa s-icon-delete fa-fw"></i>
                        </button>
                      }
                      @if (item.status === 0) {
                        <button class="mt-1 mb-1 btn btn-danger btn-sm" type="button" (click)="openDeleteModal(item)">
                          <i class="fa s-icon-delete fa-fw"></i>
                        </button>
                      }
                    </td>
                </tr>
              }
            </tbody>
          </table>
          @if (items.length > 0) {
            <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
          } @else {
            <ul class="pagination pull-right"></ul>
          }
        </div>
      </div>
    </div>
  </div>
  @if (showEditModal && selectedMenu) {
    <div class="modal-backdrop fade show"></div>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"> 編集</h5>
            <button type="button" class="close" (click)="closeMenuModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form novalidate #editMenuForm="ngForm">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">予約種別</label>
                    <div class="col-md-8">
                      <label class="form-control" readonly>{{selectedMenu.menuType === 0 ? '会員向け' : '非会員向け'}}</label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">メニュー名</label>
                    <div class="col-md-8">
                      <input type="text" class="form-control" name="editMenuName"
                        [(ngModel)]="selectedMenu.menuName" sfMaxLength="225" required>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">予約枠</label>
                    <div class="col-md-8">
                      <label class="form-control" readonly>{{formatTimePerSlot(selectedMenu)}}</label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">予約表示時間</label>
                    <div class="col-md-8">
                      <label class="form-control" readonly>{{formatRequiredTime(selectedMenu)}}</label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">金額</label>
                    <div class="col-md-8">
                      <label class="form-control" readonly>{{formatMenuAmount(selectedMenu)}}</label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">説明文</label>
                    <div class="col-md-8">
                      <textarea class="form-control" rows="10" name="editDescription"
                        [(ngModel)]="selectedMenu.description" sfMaxLength="225"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn bg-close text-white" type="button" (click)="closeMenuModal()">
                <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
              </button>
              <button type="button" class="btn btn-success" [disabled]="editMenuForm.invalid" (click)="updateMenu()">
                <i class="fa s-icon-save fa-fw"></i>&nbsp;保存
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  }
  @if (showAddModal && selectedMenu) {
    <div class="modal-backdrop fade show"></div>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"> 新規作成</h5>
            <button type="button" class="close" (click)="closeMenuModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form novalidate #newMenuForm="ngForm">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">予約種別</label>
                    <div class="col-md-8">
                      <select class="form-control" name="menuType" [(ngModel)]="selectedMenu.menuType" required>
                        <option [ngValue]="null">-- 選択してください --</option>
                        @for (menuType of menuTypes; track menuType.id) {
                          <option [ngValue]="menuType.id">{{menuType.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">メニュー名</label>
                    <div class="col-md-8">
                      <input type="text" class="form-control" name="menuName"
                        [(ngModel)]="selectedMenu.menuName" sfMaxLength="225" required>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">予約枠</label>
                    <div class="col-md-8">
                      <select class="form-control" name="timePerSlot" [(ngModel)]="selectedMenu.timePerSlot" required>
                        <option [ngValue]="null">-- 選択してください --</option>
                        @for (timePerSlot of timePerSlots; track timePerSlot.id) {
                          <option [ngValue]="timePerSlot.id">{{timePerSlot.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">予約表示時間(分)</label>
                    <div class="col-md-8">
                      <input type="number" class="form-control" name="requiredTime"
                        [(ngModel)]="selectedMenu.requiredTime"
                        [max]="selectedMenu.timePerSlot ? selectedMenu.timePerSlot * reserveSlot : null"
                        min="1" required>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">金額</label>
                    <div class="col-md-8">
                      <select class="form-control" name="productId" [(ngModel)]="selectedMenu.productId" required>
                        <option [ngValue]="null">-- 選択してください --</option>
                        @for (product of filteredProductsForSelectedMenu(); track product.id) {
                          <option [ngValue]="product.id">({{formatProductAmount(product)}}) {{product.name}}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">説明文</label>
                    <div class="col-md-8">
                      <textarea class="form-control" rows="10" name="description"
                        [(ngModel)]="selectedMenu.description" sfMaxLength="225"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn bg-close text-white" type="button" (click)="closeMenuModal()">
                <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
              </button>
              <button type="button" class="btn btn-success" [disabled]="newMenuForm.invalid" (click)="saveMenu()">
                <i class="fa s-icon-save fa-fw"></i>&nbsp;保存
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  }
  @if (showDeleteModal) {
    <div class="modal-backdrop fade show"></div>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content border-danger">
          <div class="modal-header bg-danger">
            <h5 class="modal-title"> メニューの削除</h5>
            <button type="button" class="close" (click)="showDeleteModal = false">
              <span class="text-white" aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: #FFF6F8 !important">
            <div class="form-group row">
              <label class="col-md-12 col-form-label">メニューを削除します。すでに予約済みのメニューは予約から削除出来ません。よろしいですか。</label>
            </div>
          </div>
          <div class="modal-footer" style="background-color: #FFF6F8 !important">
            <button class="btn bg-close text-white" type="button" (click)="showDeleteModal = false">
              <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
            </button>
            <button class="btn btn-danger" type="button" (click)="doDelete()">
              <i class="fa s-icon-delete"></i>&nbsp;削除
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
  `
})
export class PtReservationMenuComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private ptMenuService = inject(PtReservationMenuService);
  private studioSelection = inject(StudioSelectionService);

  studios: any[] = [];
  selectedStudio: any = null;
  items: any[] = [];
  products: any[] = [];
  searching = false;
  showAddModal = false;
  showEditModal = false;
  showDeleteModal = false;
  selectedItem: any = null;
  selectedMenu: any = null;
  readonly reserveSlot = RESERVE_SLOT;
  readonly menuTypes = [
    { id: 0, name: '会員向け' },
    { id: 1, name: '非会員向け' },
  ];
  readonly timePerSlots = this.createTimePerSlots();
  readonly pageLimit = 300;
  pageIndex = 0;

  get pagedItems(): any[] {
    return this.items.slice(this.pageIndex * this.pageLimit, (this.pageIndex + 1) * this.pageLimit);
  }
  get totalPages(): number {
    return Math.ceil(this.items.length / this.pageLimit);
  }
  goToPage(p: number): void {
    this.pageIndex = Math.max(0, Math.min(p, this.totalPages - 1));
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('予約管理', 'fa fa-calendar');
    this.studios = await this.studioService.list('all') ?? [];
    const restored = this.studioSelection.restore(this.studios, SESSION_KEY);
    if (restored) {
      this.selectedStudio = restored;
      await this.load();
    }
  }

  async onStudioChange(): Promise<void> {
    this.items = [];
    this.products = [];
    this.pageIndex = 0;
    if (!this.selectedStudio) { this.studioSelection.clear(SESSION_KEY); return; }
    this.studioSelection.save(this.selectedStudio, SESSION_KEY);
    await this.load();
  }

  async load(): Promise<void> {
    if (!this.selectedStudio) return;
    this.searching = true;
    try {
      const [items, products] = await Promise.all([
        this.ptMenuService.getAll(this.selectedStudio.id),
        this.studioService.getProduct(this.selectedStudio.id),
      ]);
      this.items = items ?? [];
      this.products = (products ?? []).filter((p: any) => p.status === 0 && (p.productType === 4 || p.productType === 0));
    } finally {
      this.searching = false;
    }
  }

  formatTimePerSlot(item: any): string {
    const value = Number(item?.timePerSlot);
    if (!Number.isFinite(value)) return '';
    return `${value * RESERVE_SLOT}分`;
  }

  formatRequiredTime(item: any): string {
    const value = Number(item?.requiredTime ?? item?.duration);
    return Number.isFinite(value) ? `${value}分` : '';
  }

  formatMenuAmount(item: any): string {
    const amount = this.getMenuAmount(item);
    return amount === null ? '' : this.formatCurrency(amount);
  }

  formatProductAmount(product: any): string {
    const amount = this.getMenuAmount({ product });
    return amount === null ? '' : this.formatCurrency(amount);
  }

  private getMenuAmount(item: any): number | null {
    const baseAmount = Number(item?.product?.amount ?? item?.amount ?? item?.price);
    if (!Number.isFinite(baseAmount)) return null;
    const rawRate = Number(item?.product?.taxRate?.rate ?? item?.taxRate?.rate ?? item?.taxRate ?? 0);
    const taxRate = Number.isFinite(rawRate) ? rawRate : 0;
    return Math.floor(baseAmount * (1 + taxRate));
  }

  private formatCurrency(amount: number): string {
    return `¥${amount.toLocaleString()}`;
  }

  filteredProductsForSelectedMenu(): any[] {
    if (!this.selectedMenu || this.selectedMenu.menuType == null) return [];
    if (this.selectedMenu.menuType === 1) {
      return this.products.filter((p: any) => p.amount === 0 && p.productType === 0);
    }
    return this.products.filter((p: any) => p.productType === 4);
  }

  openAddModal(): void {
    this.selectedMenu = {
      menuType: null,
      menuName: '',
      timePerSlot: null,
      requiredTime: null,
      productId: null,
      description: '',
    };
    this.showAddModal = true;
  }

  openEditModal(item: any): void {
    this.selectedMenu = JSON.parse(JSON.stringify(item));
    this.showEditModal = true;
  }

  closeMenuModal(): void {
    this.showAddModal = false;
    this.showEditModal = false;
    this.selectedMenu = null;
  }

  async saveMenu(): Promise<void> {
    if (!this.selectedStudio || !this.selectedMenu) return;
    await this.ptMenuService.upsert({
      studioId: this.selectedStudio.id,
      menuType: this.selectedMenu.menuType,
      menuName: this.selectedMenu.menuName,
      timePerSlot: this.selectedMenu.timePerSlot,
      requiredTime: this.selectedMenu.requiredTime,
      productId: this.selectedMenu.productId,
      description: this.selectedMenu.description,
    });
    this.closeMenuModal();
    await this.load();
  }

  async updateMenu(): Promise<void> {
    if (!this.selectedMenu?.id) return;
    await this.ptMenuService.upsert({
      id: this.selectedMenu.id,
      menuName: this.selectedMenu.menuName,
      description: this.selectedMenu.description,
    });
    this.closeMenuModal();
    await this.load();
  }

  async enable(item: any): Promise<void> {
    await this.ptMenuService.upsert({ id: item.id, status: 1 });
    await this.load();
  }

  async disable(item: any): Promise<void> {
    await this.ptMenuService.upsert({ id: item.id, status: 0 });
    await this.load();
  }

  openDeleteModal(item: any): void {
    this.selectedItem = item;
    this.showDeleteModal = true;
  }

  async doDelete(): Promise<void> {
    this.showDeleteModal = false;
    await this.ptMenuService.remove({ id: this.selectedItem.id });
    await this.load();
  }

  private createTimePerSlots(): Array<{ id: number; name: string }> {
    const result: Array<{ id: number; name: string }> = [];
    for (let minutes = 30; minutes <= 120; minutes += RESERVE_SLOT) {
      result.push({ id: minutes / RESERVE_SLOT, name: `${minutes}分` });
    }
    return result;
  }
}
